/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/**
 *
 * Update Cart count in Drawer.
 */

async function fetchCart() {
  let requestUrl = new Request('/cart.js');

  const data = await fetch(requestUrl)
    .then(function (response) {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      } else {
        return response.json();
      }
    })

  return data;
}

function updateCartCount(item_count) {
  const cartCount = document.querySelector('#drawer_cart_item_count');
  const cartArticleText = document.querySelector('#drawer_cart_item_text');

  if (!cartCount && !cartArticleText) {
    return;
  }

  cartCount.innerHTML = item_count;

  if (item_count < 2) {
    cartArticleText.innerHTML = window.languages.cartOptimizeOneArticle;
  } else if (item_count >= 2) {
    cartArticleText.innerHTML = window.languages.cartOptimizeMoreArticle;
  }
}

document.addEventListener('product:added', async function (event) {
  const cartData = await fetchCart();
  updateCartCount(cartData.item_count);
});
